import { type ModuleId } from '@autone/redux/data-ingestion';
import { type GeneralCommonPaths } from '@autone/translations';

// Map application identifiers to translation keys
export const moduleIdTranslationKeyMap: Record<ModuleId, GeneralCommonPaths> = {
  BUY: 'module.buying.name',
  REPLEN: 'module.replenishment.name',
  RO: 'module.reorder.name',
  RBL: 'module.rebalancing.name',
  'RBL-NEW': 'module.rebalancing-new.name',
};
